import Vue, { PluginObject } from 'vue';
import auth from './auth';
import users from './users';
import products from './products';

export interface IServicesModule {
  auth: typeof auth;
  users: typeof users;
  products: typeof products;
}
export const api: IServicesModule = {
  auth,
  users,
  products,
};
const plugin: PluginObject<any> = {
  install(_Vue: typeof Vue, options: any) {
    Object.defineProperties(_Vue.prototype, {
      api: {
        get() {
          return api;
        },
      },
      $api: {
        get() {
          return api;
        },
      },
    });
  },
};

Vue.use(plugin);
